import { render, staticRenderFns } from "./ViewDocumentModal.vue?vue&type=template&id=a1da234a"
import script from "./ViewDocumentModal.vue?vue&type=script&lang=ts"
export * from "./ViewDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports